// extracted by mini-css-extract-plugin
module.exports = {"navigation":"_3tZ3CHtw6jaLux6aQ1erRx"};